export default "__VITE_ASSET__CBo2Ad41__"